// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3oN9I","disabled":"FileBtn_disabled__3f6-_","warn":"FileBtn_warn__ipXr6","fade":"FileBtn_fade__1sY2O"};